import { edu } from '../../portfolio'
import './Education.css'

const Education = () => (
  <section id='education'>
    <h2 className='section__title padding-top'>Education.</h2>
    {edu.map((eduObj) => (
      <div className='about' key={eduObj.id}>
        <div className='row'>
          <div className='columnL left'>
            <p>{eduObj.course && eduObj.course}</p>
            <p>{eduObj.year}</p>
          </div>
          <div className='columnR right'>
            <p>{eduObj.uniname}</p>
            <p>{eduObj.description && eduObj.description}</p>
          </div>
        </div>
      </div>
    ))}
  </section>
)

export default Education
